import { useEffect } from 'react';
import { Outlet, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

const LAST_SEGMENT_KEY = 'saee:lastPathSegment';
const NON_PERSIST_SEGMENTS = new Set(['forbidden', 'access-denied']);

/**
 * Route layout for broker dashboard pages. Persists the active path segment
 * to localStorage so authenticated users resume their last visited page after login.
 * Renders <Outlet /> for children.
 */
export function DashboardRoute() {
  const { lang: _lang } = useParams<{ lang: string }>();
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  const parts = pathname.split('/').filter(Boolean);
  const segment = parts[1] || '';

  useEffect(() => {
    if (!isAuthenticated || !segment) return;
    if (NON_PERSIST_SEGMENTS.has(segment)) return;
    window.localStorage.setItem(LAST_SEGMENT_KEY, segment);
  }, [segment, isAuthenticated]);

  return <Outlet />;
}
